import { Grid } from "../components"

/**
 * True below antd's `md` breakpoint (768px) — used to switch sidebar
 * navigation to a hamburger-triggered Drawer on phones.
 */
export const useIsMobileViewport = (): boolean => {
  const screens = Grid.useBreakpoint()
  return screens.md === false
}
